import React, { useCallback, useContext } from 'react';

import { AssigmentPositionContext } from '../../assigment-position.context';
import AssigmentPositionForm from '../form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(AssigmentPositionContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <AssigmentPositionForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
